import { memo, useCallback } from 'react';
import { locationSlice } from '../Location/locationReducer';
import { LOCATION_NAMES } from '../Location/locationConstants';
import { setIsIncompleteDepositClosedByUser } from '../Deposit/depositReducer';
import { useDispatch, useSelector } from 'react-redux';
import { getIsLocationPlatformMobileSelector } from '../Location/locationSelectors';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext';
import amountFormat from '../../utils/amountFormat';
import {
    getIncompleteDepositSelector,
    getIsIncompleteDepositWidgetAvailableSelector,
} from '../Deposit/depositSelectors';
import IncompleteDeposit from './components/IncompleteDeposit';

function IncompleteDepositWidget({ className }: { className?: string }) {
    const dispatch = useDispatch();
    const isPlatformMobile = useSelector(getIsLocationPlatformMobileSelector);
    const { getLangPath } = useLangContext();
    const isIncompleteDepositWidgetAvailable = useSelector(getIsIncompleteDepositWidgetAvailableSelector);
    const incompleteDeposit = useSelector(getIncompleteDepositSelector);

    const handleCompleteDeposit = useCallback(() => {
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.DEPOSIT }));
    }, [dispatch]);

    const handleWidgetClose = useCallback(() => {
        dispatch(setIsIncompleteDepositClosedByUser(true));
    }, [dispatch]);

    if (!isIncompleteDepositWidgetAvailable) return null;

    return <IncompleteDeposit onClick={handleCompleteDeposit} onClose={handleWidgetClose}
                              badgeText={getLangPath('incomplete_deposit.title')}
                              mainText={getLangPath('incomplete_deposit.amount_via_payment', {
                                  amount: `${amountFormat(incompleteDeposit?.amount || 0, 2, null, true)} ${incompleteDeposit?.currencyUnit}`,
                                  payment_name: incompleteDeposit?.paymentName,
                              })} buttonText={getLangPath('incomplete_deposit.complete')}
                              variant={isPlatformMobile ? 'horizontal' : 'vertical'}
                              paymentKey={incompleteDeposit?.paymentKey} className={className}/>;
}

export default memo(IncompleteDepositWidget);
